import {useRef, useEffect, ReactNode} from 'react';
import {createPortal} from 'react-dom';

type PortalType = {
  selector?: string;
  children?: ReactNode;
};

export const Portal = ({children, selector}: PortalType) => {
  const elementRef = useRef<Element>(document.createElement('div'));

  useEffect(() => {
    const _el = elementRef.current;

    _el.setAttribute('id', Date.now().toString());

    const wrapper = selector ? document.querySelector(selector) : document.body;

    wrapper?.appendChild(_el);

    return () => {
      wrapper?.removeChild(_el);
    };
  }, []);

  // eslint-disable-next-line react-hooks/refs
  return createPortal(children, elementRef.current);
};
